import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: RedirectToLocale,
});

function RedirectToLocale() {
  return <Navigate to="/$locale" params={{ locale: "en" }} replace />;
}
